import { ChartCandidateSelector } from '@/features/(charts)/chart-controller/ui/components';
import { ChartCandidateExportButton } from '@/features/(charts)/chart-controller/ui/components/chart-candidate-export-button';
import { Pane } from '@/features/(charts)/chart-controller/ui/components/ControllerPane';
import ChartCandidateTable from '@/features/(charts)/chart-list/ui/chart-candidate-table';

type Props = {
  chartInfo: ChartContextProps;
};
export default function CustomChartCandidatesTable({ chartInfo }: Props) {
  return (
    <Pane title="Selected" initialOpen className="bg-white border">
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <ChartCandidateSelector chartInfo={chartInfo} />
          <ChartCandidateExportButton chartInfo={chartInfo} />
        </div>
        <ChartCandidateTable chartInfo={chartInfo} />
      </div>
    </Pane>
  );
}
